<div [ngClass]="type" class="subscription-banner">
  <rt-icon [name]="iconName" size="small" margin-right-small-x></rt-icon>
  <span margin-right-small-xx [innerHTML]="bannerMessage"> </span>
  <a class="link" *ngIf="!!linkText" [routerLink]="linkUrl" (click)="linkClick.emit()">
    {{ linkText }}
  </a>
  <rt-icon-button
    *ngIf="isDismissible"
    (click)="onCloseClick($event)"
    margin-left-auto
    class="close-btn"
    size="small"
    variant="plain"
    iconName="close"
    shape="square"
  >
  </rt-icon-button>
</div>
